import type { EffectEvent, NodeEvent } from "@skilitics/nautilus-core-designer-data";

// Node lifecycle events.
export const nodeLifecycleEventName = (type: NodeEvent["type"], typeId?: string, id?: number) =>
  [type, typeId, id].filter((v) => !!v).join(".");

export const nodeAddedEventName = ({ typeId }: { typeId: string }, id?: number) =>
  nodeLifecycleEventName("NODE_ADDED", typeId, id);

export const nodeRemovedEventName = ({ typeId }: { typeId: string }, id?: number) =>
  nodeLifecycleEventName("NODE_REMOVED", typeId, id);

export const nodeLifecycleEventTypes = [
  "NODE_ADDED",
  "NODE_REMOVED",
  "NODE_UPDATED",
  "NODE_SLOT_MOVED",
] satisfies Readonly<NodeEvent["type"]>[];

// Effect lifecycle events.
export const effectLifecycleEventName = (
  type: EffectEvent["type"],
  nodeId?: number,
  buildableName?: string,
  effectId?: number,
) => [type, nodeId, buildableName, effectId].filter((v) => !!v).join(".");

export const effectAddedEventName = (
  { nodeId, buildableName }: { nodeId: number; buildableName: string },
  effectId?: number,
) => effectLifecycleEventName("EFFECT_ADDED", nodeId, buildableName, effectId);

export const effectRemovedEventName = (
  { nodeId, buildableName }: { nodeId: number; buildableName: string },
  effectId?: number,
) => effectLifecycleEventName("EFFECT_REMOVED", nodeId, buildableName, effectId);
